define('C3.ShoppingExtensions.IncomingEquipment.HomeView'
, 	[
		'c3_shoppingextensions_incomingequipment_homeview.tpl',
        'Profile.Model',
        //'SC.Configuration',
        'Utils',    
		'SCView',
        'C3.ShoppingExtensions.IncomingEquipment.Collection'
	],
function (
		c3_shoppingextensions_incomingequipment_homeview_tpl,
        ProfileModel,
       // Configuration,
        Utils,
		SCViewModule,
        IncomingEquipmentCollection
){
	'use strict';

	 var SCView = SCViewModule.SCView;

	  function HomeIncomingEquipment (options) {
        SCView.call(this, options);

        this.template = c3_shoppingextensions_incomingequipment_homeview_tpl;
        this.options = options;
        this.application = options.application;

        this.collection = options.collection;

        this.clickIncomingEquipment = function clickIncomingEquipment(e) {
            
            //e.stopPropagation();
            e.preventDefault();

            var ele = $(e.currentTarget)
            ,   eleHashTag = ele.attr('data-hashtag')
            ,   eleSku = ele.attr('data-sku')
            //console.log(eleHashTag)
            if(eleHashTag){
                Backbone.history.navigate(eleHashTag, {
                        trigger: true
                    });
                //var sku = self.model.get('itemid')
                var carouselItemsAppend = $('.NewArrivals-Items-Append');
                carouselItemsAppend.html("<script>window.dataLayer = window.dataLayer || [];window.gtag('event', 'incomingequipmentitems', {'product': '"+eleSku+"','page_location': '/' });</script>");
                   
            }
        }

    }

    HomeIncomingEquipment.prototype = Object.create(SCView.prototype);
    HomeIncomingEquipment.prototype.constructor = HomeIncomingEquipment;

   /* HeaderMenuMyAccountMobileView.prototype.initialize = function (options) {
        this.collection = new IncomingEquipmentCollection();
    }*/


    HomeIncomingEquipment.prototype.render = function () {
        SCView.prototype.render.call(this);

           var promise = jQuery.Deferred();
           var self = this;

           var homepageResultsCount = 3;

          var windowWidth = jQuery(window).width();
          //console.log(windowWidth)
          if(windowWidth >= 992 && windowWidth <= 1098)
          {
            homepageResultsCount = 2;
          }
                    
           this.collection
            .fetch({
                data: {
                    pageNumber: 1,
                    resultsPerPage: homepageResultsCount
                },
                success:function (res){
                    if(res)
                    {
                        //console.log(res)
                        var models = res.models[0]
                        var searchRes = models.get('searchResults');
                        
                        var searchCols = models.get('searchColLabels')
                        if(searchRes.length > 0)
                        {
                            searchRes = searchRes.slice(0, homepageResultsCount)
                            
                            //console.log(searchRes)

                            $('.loading-wait').css('display','none')
                            _.each(searchCols, function(cols) {
                                $('.incoming-equipment-home .ie-search-results-table-header-home .ie-search-results-table-header-row').append('<th class="ie-search-results-table-header-row-column-middle '+cols+'">'+cols+'</th>')
                            });

                            var tdBody = $('#ie-search-results-body-home');
                            var appendTbody = '';
                            _.each(searchRes, function(result) {  

                                var resValue = result.values;  

                                var additionalValues = result.additionalValues
                                ,   isonline = false
                                ,   url = ''
                                
                                if(additionalValues.Display_In_WebSite == true){
                                    isonline = true;
                                    url = additionalValues.Item_URL_Component;
                                }

                                appendTbody+= '<tr class="recordviews-actionable">';  
                                
                                _.each(resValue, function(key,value) {

                                    appendTbody+= '<td class="recordviews-actionable-" data-name="'+value+'">';
                                    appendTbody+= '<span class="recordviews-actionable-label">'+value+': </span>'
                                    if(value == 'SKU')
                                        {
                                            if(isonline == true)
                                                appendTbody+= '<a data-sku="'+key+'" data-hashtag="/'+additionalValues.Item_URL_Component+'" data-action="click-incoming-equipment" href="'+url+'" class="sku-link">'+key+'</a>'
                                        }
                                    else
                                    appendTbody+= '<span class="recordviews-actionable-value">'+key+'</span>'
                                    
                                    appendTbody+= '</td>';
                                
                                })                                                      
                                appendTbody+= '</tr>';
                            });

                            tdBody.append(appendTbody)
                            
                        }
                        else
                        {
                            $('.loading-wait').css('display','none')
                            $('.results-section-home').append('<div>There is no data available</div>')
                        }
                        
                    }
                    
                },
                error: function(model, jqXhr) {
                    // this will stop the ErrorManagment module to process this error
                    // as we are taking care of it
                    jqXhr.preventDefault = true;
                }
            })
            .always(function() {
                promise.resolve();
            });

         return promise;
    }

    HomeIncomingEquipment.prototype.getEvents = function() {
            return {
                'click [data-action="click-incoming-equipment"]':'clickIncomingEquipment'
            };
        }

    HomeIncomingEquipment.prototype.getContext = function () {

        return {

        }
    }

    return HomeIncomingEquipment
});
